import React, { Component } from "react";
import { ProductConsumer } from "../../context";


export default class AdminLoginForm extends Component {
    render() {
        return (
            <ProductConsumer>
			{(value) => {
				const { password,email,handleChange,passworderror,emailerror,handleLogin} = value;

            return (
                <div className="container">
                    <form>

                        <h3>Log in</h3>

                        <div className="form-group">
                            <label>Email</label>
                            <input 
                                type="email" 
                                className="form-control" 
                                placeholder="Enter email" 
                                id="email" 
                                name="email" 
                                onChange={handleChange}
                                value={email}
                                />
                                <p className="errorMsg">{emailerror}</p>

                        </div>

                        <div className="form-group">
                            <label>Password</label>
                            <input 
                            type="password" 
                            className="form-control" 
                            placeholder="Enter password"
                            id="password" 
                            name="password" 
                            onChange={handleChange}
                            value={password}
                            />
                            <p className="errorMsg">{passworderror}</p>
                        </div>

                    
                    
                    </form>
                    <button onClick={handleLogin} className='main-link' style={{margin:'0.75rem'}}>Log ind</button>	
                </div>
                 );
                }}
        </ProductConsumer>
        );
    }
}

